/* Cart drawer + quick add — talks to /cart/add.js, /cart/change.js, /cart.js */
(function () {
  'use strict';

  var drawer, overlay, itemsEl, footEl, emptyEl, countBubbles, subtotalEl;

  /* Escape HTML in strings injected via innerHTML (defense against stored XSS via product/variant titles) */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function cache() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return false;
    overlay = document.querySelector('[data-cart-overlay]');
    itemsEl = drawer.querySelector('[data-cart-items]');
    footEl = drawer.querySelector('[data-cart-foot]');
    emptyEl = drawer.querySelector('[data-cart-empty]');
    countBubbles = document.querySelectorAll('[data-cart-count]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    return true;
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function render(cart) {
    countBubbles.forEach(function (b) { b.textContent = '(' + cart.item_count + ')'; });
    var hasItems = cart.items && cart.items.length > 0;
    footEl.hidden = !hasItems;
    emptyEl.hidden = hasItems;

    if (hasItems) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var opts = (item.options_with_values || []).map(function (o) { return o.value; }).join(' / ');
        var img = item.image
          ? '<img class="cart-item__img" src="' + esc(item.image.replace(/(\.[a-z]+)$/i, '_160x$1')) + '" alt="' + esc(item.title) + '" loading="lazy">'
          : '';
        return '<div class="cart-item" data-key="' + esc(item.key) + '">' + img +
          '<div><p class="cart-item__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
          (opts ? '<p class="cart-item__variant">' + esc(opts) + '</p>' : '') +
          '<div class="cart-item__row">' +
          '<span class="cart-item__qty">' +
          '<button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<span class="cart-item__price">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-remove>' + drawer.getAttribute('data-label-remove') + '</button>' +
          '</div></div>';
      }).join('');
      subtotalEl.textContent = money(cart.total_price);
    } else {
      itemsEl.innerHTML = '';
    }
    announce();
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function addToCart(formData, done) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { open(); if (done) done(); })
      .catch(function () { if (done) done(); });
  }

  function init() {
    if (!cache()) return;

    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { refresh().then(open); });
    });
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Quantity + remove inside the drawer (event delegation) */
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cart-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        var current = parseInt(row.querySelector('.cart-item__qty span').textContent, 10);
        changeLine(key, Math.max(0, current + parseInt(qtyBtn.getAttribute('data-qty'), 10)));
      }
      if (e.target.closest('[data-remove]')) changeLine(key, 0);
    });

    /* Quick add from product cards */
    document.querySelectorAll('form[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-adding-label') || 'Adding…';
        addToCart(new FormData(form), function () {
          btn.disabled = false;
          btn.textContent = original;
        });
      });
    });

    /* Initial paint */
    refresh();
  }

  /* Exposed for product.js */
  window.A1Cart = { addToCart: addToCart, open: open, close: close, refresh: refresh };

  document.addEventListener('DOMContentLoaded', init);
})();
